export default {"src":"/_next/static/media/how-4.26f74a84.svg","height":81,"width":87,"blurWidth":0,"blurHeight":0};